import {
  HeaderButton as RNEHeaderButton,
  type HeaderButtonProps as RNEHeaderButtonProps
} from '@react-navigation/elements'
import { useIsFocused } from '@react-navigation/native'
import { type Icon as IconType } from '@tabler/icons-react-native'
import { clsx } from 'clsx'
import { ComponentRef, forwardRef } from 'react'
import { type AccessibilityState } from 'react-native'

import { Icon, type IconProps } from '@/components'

export interface HeaderButtonProps extends Omit<RNEHeaderButtonProps, 'children'> {
  accessibilityState?: AccessibilityState
  className?: IconProps['className']
  IconComponent: IconType
}

export const HeaderButton = forwardRef<ComponentRef<typeof RNEHeaderButton>, HeaderButtonProps>(
  ({ className, IconComponent, style, ...props }, ref) => {
    const isFocused = useIsFocused()

    return isFocused ? (
      <RNEHeaderButton
        ref={ref}
        style={[
          {
            alignItems: 'center',
            justifyContent: 'center',
            paddingHorizontal: 0,
            width: 40,
            height: 40,
            margin: 0
          },
          style
        ]}
        {...props}
      >
        <Icon
          as={IconComponent}
          className={clsx('h-6 w-6', className)}
          strokeWidth={2.5}
        />
      </RNEHeaderButton>
    ) : null
  }
)

HeaderButton.displayName = 'HeaderButton'
